<template>
    <div class="modal fade modal-confirmRegisterselect" id="modalSelectContract">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Modal body -->
                <div class="modal-body">
                    <div class="center-modal">
                        <div class="select-contract-head">旅行契約</div>
                        <div class="select-contract">
                            <button class="contract-btn" @click="viewContracts(Constants.BeforeContractScreenType)">
                                <i class="icon-before-contract"></i>
                                <div style="font-size: 20px">契約書類</div>一覧
                            </button>
                            <button class="contract-btn" @click="viewContracts(Constants.AfterContractScreenType)">
                                <i class="icon-change-contract"></i>
                                <div style="font-size: 20px">変更書類</div>一覧
                            </button>
                            <button class="contract-btn" @click="viewContracts(Constants.ConfirmContractScreenType)">
                                <i class="icon-confirm-contract"></i>
                                <div style="font-size: 20px">確定書類</div>一覧
                            </button>
                        </div>

                        <div class="select-contract-head">業務委託契約</div>
                        <div class="select-contract" style="justify-content:flex-start">
                            <button class="subcontract-btn" @click="viewSubContracting(Constants.VoucherType.contract_outsourcing.id)">
                                <i class="icon-sub-contract"></i>
                                <div style="font-size: 20px">業務委託</div>契約書
                            </button>
                            <button class="subcontract-btn" @click="viewSubContracting(Constants.VoucherType.change_contract.id)">
                                <i class="icon-change-sub-contract"></i>
                                <div style="font-size: 20px">変更</div>契約書
                            </button>
                        </div>

                        <div class="select-contract-head">事業パートナーとの再委託契約書</div>
                        <div class="select-contract" style="justify-content:flex-start">
                            <button class="partner-contract-btn" @click="viewSubContracting(Constants.VoucherType.partner_contract.id)">
                                <i class="icon-partner-contract"></i>
                                <div style="font-size: 20px">委託先</div>契約書
                            </button>
                        </div>

                        <div style="text-align:right; padding-top: 10px;">
                            <button class="other-contract-btn" @click="viewSubContracting(Constants.VoucherType.contract_other.id)">
                                <i class="icon-other-contract"></i>
                                <div style="font-size: 20px">その他</div>契約書
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
import Utils from '@/helpers/utils';
import StorageService from '@/services/common/storage.service';

export default {
    name: "PcSelectVoucherType",
    data () {
        return {
            Constants: Constants,
        };
    },
    methods: {
        viewContracts (screenType) {
            const tourInfo = StorageService.getTour();
            if (Utils.isEmptyObj(tourInfo)) {
                this.$toasted.error(this.$t('error.not_tour'), {icon: 'fa-exclamation-triangle'});
                return;
            }

            $("#modalSelectContract").modal("hide");
            this.$router.push({path: '/voucher/contracts', query:{ screenType: screenType }});
        },
        viewSubContracting(voucherTypeId) {
            $("#modalSelectContract").modal("hide");
            if (voucherTypeId == Constants.VoucherType.contract_outsourcing.id) {
                this.$router.push({path: '/voucher/subContracts', query:{ screenType: 1 }});
            } else if (voucherTypeId == Constants.VoucherType.change_contract.id) {
                this.$router.push({path: '/voucher/subContracts', query:{ screenType: 2 }});
            } else if (voucherTypeId == Constants.VoucherType.contract_other.id) {
                this.$router.push({path: '/voucher/subContracts', query:{ screenType: 3 }});
            } else if (voucherTypeId == Constants.VoucherType.partner_contract.id) {
                this.$router.push({path: '/voucher/subContracts', query:{ screenType: 4 }});
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/SelectContractModal.vue